import './script/refs';
import './script/modalButton';
import './script/gallery';
import './script/cardMarkup';
import './script/onOpenCard';
import './script/filter';
import './script/microphone';
import './script/onCloseModal';
import './script/scrollUp';
import './script/localStorageKey';
import './script/loader';
import './script/auth-modal';
import './script/signup-modal';
import './script/signin-modal';
import './script/modal_developer';
